import React, { useState } from 'react'
import { getInitialLang } from '../../Common'
import { $MAX_WIDTH } from '../../Consts'
import { $FEATURES } from './Features'

const blueLight = '#7AC4FF'
const blue = '#007AFF'
const blueDark = '#0051D4'
const blueMidDark = '#003DA6'
const offWhite = '#FFFFFF'
const veryLightGrey = '#F5F8FD'
const cardGradient = `linear-gradient(180deg, ${offWhite} 0%, ${veryLightGrey} 100%)`

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
    <polyline points="20 6 9 17 4 12" stroke={blueDark} strokeWidth={3} strokeLinecap="round" />
  </svg>
)

type CardProps = { title: string; bullets: string[]; icon: React.ReactElement }

const FeatureCard: React.FC<CardProps> = ({ title, bullets, icon }) => {
  const [hover, setHover] = useState(false)
  const cardStyle: React.CSSProperties = {
    background: cardGradient,
    borderRadius: 14,
    padding: '1.9rem 1.6rem 1.6rem',
    boxShadow: hover ? '0 10px 28px rgba(0, 122, 255, 0.28)' : '0 6px 18px rgba(0,0,0,0.06)',
    transition: 'transform 0.25s, box-shadow 0.25s',
    transform: hover ? 'translateY(-6px)' : 'translateY(0)',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    cursor: 'default',
  }
  const cardTitle: React.CSSProperties = {
    fontSize: '1.2rem',
    fontWeight: 700,
    color: blue,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    gap: '0.6rem',
  }
  const bulletRow: React.CSSProperties = { display: 'flex', alignItems: 'flex-start', gap: '0.55rem', lineHeight: 1.45 }
  const bulletTxt: React.CSSProperties = { margin: 0, textAlign: 'left' }
  return (
    <div style={cardStyle} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <h3 style={cardTitle}>
        {icon}
        {title}
      </h3>
      <div>
        {bullets.map((b) => (
          <div key={b} style={bulletRow}>
            <CheckIcon />
            <p style={bulletTxt}>{b}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

const FeatureTiles: React.FC = () => {
  const [lang] = useState<'en' | 'zh'>(getInitialLang)
  const sectionWrap: React.CSSProperties = { maxWidth: $MAX_WIDTH, margin: '0 auto', padding: '3.5rem 1.25rem' }
  const sectionTitle: React.CSSProperties = { fontSize: '1.875rem', fontWeight: 700, color: blueDark, marginBottom: '2.4rem', textAlign: 'center' }
  const cardGrid: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(330px, 1fr))',
    gap: '2rem',
  }
  return (
    <div style={cardGrid}>
      {$FEATURES[lang].map((f) => (
        <FeatureCard key={f.title} {...f} />
      ))}
    </div>
  )
}

export default FeatureTiles